export const FETCHING_CUSTOMIZATION = 'FETCHING_CUSTOMIZATION';